import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import {
  collection,
  query,
  orderBy,
  onSnapshot,
  doc,
  updateDoc
} from 'firebase/firestore';
import '../Admin.css'; 

function Orders() {
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]); // Filter ചെയ്ത ഡാറ്റ കാണിക്കാൻ
  const [loading, setLoading] = useState(true);
  const [selectedOrder, setSelectedOrder] = useState(null);

  // Search & Filter States
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [dateFilter, setDateFilter] = useState("");

//Assign orders

const [agents, setAgents] = useState([]);
const [selectedOrders, setSelectedOrders] = useState([]);
const [showAssignModal, setShowAssignModal] = useState(false);
const [selectedAgent, setSelectedAgent] = useState('');

  useEffect(() => {
    const q = query(collection(db, "bookings"), orderBy("createdAt", "desc"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setOrders(data);
      setFilteredOrders(data);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
  const agentQuery = query(
    collection(db, "agents"),
    orderBy("agentName", "asc")
  );

  const unsubAgents = onSnapshot(agentQuery, (snapshot) => {
    const data = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    setAgents(data);
  });

  return () => unsubAgents();
}, []);

  // Search and Filter Logic
  useEffect(() => {
    let result = orders;

    // 1. Search (ID, Name, Phone)
    if (searchTerm) {
      result = result.filter(order => 
        order.id.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (order.customerName && order.customerName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (order.customerPhone && order.customerPhone.includes(searchTerm))
      );
    }

   

    // 2. Status Filter
    if (statusFilter !== "All") {
      result = result.filter(order => (order.orderStatus || 'Pending') === statusFilter);
    }

    // 3. Date Filter
    if (dateFilter) {
      result = result.filter(order => {
        const orderDate = order.createdAt?.toDate().toISOString().split('T')[0];
        return orderDate === dateFilter;
      });
    }

    setFilteredOrders(result);
  }, [searchTerm, statusFilter, dateFilter, orders]);

  const handleStatusChange = async (orderId, newStatus) => {
    try {
      const orderRef = doc(db, "bookings", orderId);
      await updateDoc(orderRef, { orderStatus: newStatus });
    } catch (error) {
      console.error("Status Update Error:", error);
    }
  };

  const toggleOrderSelection = (orderId) => {
  setSelectedOrders(prev =>
    prev.includes(orderId)
      ? prev.filter(id => id !== orderId)
      : [...prev, orderId]
  );
};

const toggleSelectAll = () => {
  if (selectedOrders.length === filteredOrders.length) {
    setSelectedOrders([]);
  } else {
    setSelectedOrders(filteredOrders.map(order => order.id));
  }
};

const assignOrdersToAgent = async () => {
  if (!selectedAgent) {
    alert("Please select an agent");
    return;
  }

  if (selectedOrders.length === 0) {
    alert("Please select orders");
    return;
  }

  try {
    const agent = agents.find(a => a.id === selectedAgent);

    for (const orderId of selectedOrders) {
      await updateDoc(doc(db, "bookings", orderId), {
        assignedAgentId: agent.id,
        assignedAgentName: agent.agentName,
        assignedAgentPhone: agent.phone,
        assignedAt: new Date(),
        agentStatus: "Assigned"
      });
    }

    alert(`${selectedOrders.length} orders assigned successfully`);

    setSelectedOrders([]);
    setShowAssignModal(false);
    setSelectedAgent("");

  } catch (error) {
    console.error(error);
    alert("Assignment failed");
  }
};

  if (loading) return <div className="admin-loader">Loading Orders...</div>;

  return (
    <div className="orders-container">
      
      {/* --- SEARCH & FILTER SECTION --- */}
      <div className="filter-bar">
        <div className="search-box">
          <i className="fas fa-search"></i>
          <input 
            type="text" 
            placeholder="Search by ID, Name or Phone..." 
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="filter-options">
          <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
            <option value="All">All Status</option>
            <option value="Pending">Pending</option>
            <option value="Confirmed">Confirmed</option>
            <option value="Picked Up">Picked Up</option>
            <option value="Processing">Processing</option>
            <option value="Delivered">Delivered</option>
            <option value="Cancelled">Cancelled</option>
          </select>

          <input 
            type="date" 
            value={dateFilter}
            onChange={(e) => setDateFilter(e.target.value)}
          />
          
          {(searchTerm || statusFilter !== "All" || dateFilter) && (
            <button className="clear-btn" onClick={() => {setSearchTerm(""); setStatusFilter("All"); setDateFilter("");}}>
              Clear
            </button>
          )}
        </div>
      </div>

      {selectedOrders.length > 0 && (
  <div style={{
    marginBottom:'15px',
    display:'flex',
    justifyContent:'flex-end'
  }}>
    <button
      className="clear-btn"
      onClick={() => setShowAssignModal(true)}
    >
      Assign Selected Orders
      ({selectedOrders.length})
    </button>
  </div>
)}

      <div className="admin-table-wrapper">
        <table className="admin-table">
          <thead>
            <tr>
              <th>
  <input
    type="checkbox"
    checked={
      filteredOrders.length > 0 &&
      selectedOrders.length === filteredOrders.length
    }
    onChange={toggleSelectAll}
  />
</th>
<th>Agent</th>
              <th>Order ID</th>
              <th>Customer</th>
              <th>Phone</th>
              <th>Date</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredOrders.length > 0 ? (
              filteredOrders.map((order) => (
                <tr key={order.id}>
                  <td>
  <input
    type="checkbox"
    checked={selectedOrders.includes(order.id)}
    onChange={() => toggleOrderSelection(order.id)}
  />
</td>
<td>
  {order.assignedAgentName || (
    <span style={{color:'#ef4444'}}>
      Unassigned
    </span>
  )}
</td>
                  <td className="order-id-cell">#{order.id.slice(0, 8).toUpperCase()}</td>
                  <td><strong>{order.customerName || "Guest"}</strong></td>
                  <td>{order.customerPhone}</td>
                  <td>{order.createdAt?.toDate().toLocaleDateString()}</td>
                  <td>AED {order.payment?.totalPayable}</td>
                  <td>
                    <span className={`status-badge ${order.orderStatus?.toLowerCase().replace(/\s/g, '-') || 'pending'}`}>
                      {order.orderStatus || 'Pending'}
                    </span>
                  </td>
                  <td>
                    <div className="action-btns">
                      <button className="view-btn-icon" onClick={() => setSelectedOrder(order)} title="View Details">
                        <i className="fas fa-eye"></i>
                      </button>
                      <select 
                        className="status-minimal-select"
                        value={order.orderStatus || 'Pending'}
                        onChange={(e) => handleStatusChange(order.id, e.target.value)}
                      >
                        <option value="Pending">Pending</option>
                        <option value="Confirmed">Confirmed</option>
                        <option value="Picked Up">Picked Up</option>
                        <option value="Processing">Processing</option>
                        <option value="Delivered">Delivered</option>
                        <option value="Cancelled">Cancelled</option>
                      </select>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" style={{textAlign: 'center', padding: '30px', color: '#64748b'}}>No orders found matches your filter.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* --- ENHANCED ORDER DETAILS MODAL (No Changes Here) --- */}
      {selectedOrder && (
        <div className="modal-overlay">
          <div className="modal-card animate-in">
            <div className="modal-header-premium">
              <div>
                <h2>Order Details</h2>
                <p>ID: #{selectedOrder.id.toUpperCase()}</p>
              </div>
              <button className="close-circle-btn" onClick={() => setSelectedOrder(null)}>&times;</button>
            </div>

            <div className="modal-body-scroll">
              <div className="info-grid">
                <div className="info-box">
                  <h4><i className="fas fa-user"></i> Customer Info</h4>
                  <p><strong>Name:</strong> {selectedOrder.customerName}</p>
                  <p><strong>Phone:</strong> {selectedOrder.customerPhone}</p>
                </div>
                <div className="info-box">
                  <h4><i className="fas fa-map-marker-alt"></i> Shipping Address</h4>
                  <p>
                    {selectedOrder.address?.villa || 'N/A'}, 
                    {selectedOrder.address?.street ? ` ${selectedOrder.address.street},` : ''} 
                    {selectedOrder.address?.city || ''}
                  </p>
                  <p className="address-subtext">Landmark: {selectedOrder.address?.landmark || 'None'}</p>
                  <p className="address-subtext" style={{marginTop: '5px', color: '#1e293b'}}>
                    <small><i className="fas fa-user"></i> {selectedOrder.address?.userName}</small> | 
                    <small> <i className="fas fa-phone"></i> {selectedOrder.address?.phone}</small>
                  </p>
                </div>
              </div>

              <div className="info-grid mt-3">
                <div className="info-box border-blue">
                  <h4><i className="fas fa-calendar-alt"></i> Pickup Schedule</h4>
                  <p>Date: {selectedOrder.scheduling?.pickup?.date}</p>
                  <p>Slot: {selectedOrder.scheduling?.pickup?.time}</p>
                </div>
                <div className="info-box border-green">
                  <h4><i className="fas fa-truck"></i> Delivery Schedule</h4>
                  <p>Expected: {selectedOrder.scheduling?.dropoff?.date}</p>
                  <p>Slot: {selectedOrder.scheduling?.dropoff?.time}</p>
                </div>
              </div>

              <div className="modal-items-container">
                <h4>Items Ordered</h4>
                <div className="items-header">
                  <span>Item</span>
                  <span>Qty</span>
                  <span>Price</span>
                </div>
                {selectedOrder.cart?.map((item, idx) => {

  const getKgPrice = (item, weight) => {
    if (!item.priceSlabs || weight <= 0) return 0;
    const slab = item.priceSlabs.find(
      s => weight >= Number(s.min) && weight <= Number(s.max)
    );
    return slab ? Number(slab.price) : 0;
  };

  return (
    <div key={idx} className="item-row-data">

      {/* ITEM NAME */}
      <span>{item.name}</span>

      {/* QTY / KG */}
      <span>
        {item.pricingType === 'kg'
          ? `${item.weight || 0} kg`
          : item.quantity
        }
      </span>

      {/* PRICE */}
      <span>
        AED {item.pricingType === 'kg'
          ? getKgPrice(item, item.weight || 0).toFixed(2)
          : (item.offerPrice * item.quantity).toFixed(2)
        }
      </span>

    </div>
  );
})}



}


                               <div className="payment-summary">
                  <div className="summary-row">
                    <span>Subtotal</span>
                    <span>AED {selectedOrder.payment?.totalPayable}</span>
                  </div>

                  <div className="summary-row grand-total">
                    <span>Grand Total</span>
                    <span>AED {selectedOrder.payment?.totalPayable}</span>
                  </div>
                </div>

              </div>
            </div>

            <div className="modal-footer">
              <button
                className="print-btn"
                onClick={() => window.print()}
              >
                <i className="fas fa-print"></i> Print Invoice
              </button>

              <button
                className="done-btn"
                onClick={() => setSelectedOrder(null)}
              >
                Done
              </button>
            </div>

          </div>
        </div>
      )}

      {/* ASSIGN ORDERS MODAL */}
      {showAssignModal && (
        <div className="modal-overlay">
          <div className="modal-card">

            <div className="modal-header-premium">
              <h2>Assign Orders</h2>

              <button
                className="close-circle-btn"
                onClick={() => setShowAssignModal(false)}
              >
                ×
              </button>
            </div>

            <div style={{ padding: "20px" }}>

              <p>
                Selected Orders:
                <strong> {selectedOrders.length}</strong>
              </p>

              <div
                style={{
                  maxHeight: "350px",
                  overflowY: "auto",
                  marginTop: "15px"
                }}
              >
                {agents.map(agent => (
                  <div
                    key={agent.id}
                    onClick={() => setSelectedAgent(agent.id)}
                    style={{
                      border:
                        selectedAgent === agent.id
                          ? "2px solid #2563eb"
                          : "1px solid #e5e7eb",
                      borderRadius: "12px",
                      padding: "12px",
                      marginBottom: "10px",
                      cursor: "pointer",
                      background:
                        selectedAgent === agent.id
                          ? "#eff6ff"
                          : "#fff"
                    }}
                  >
                    <strong>{agent.agentName}</strong>
                    <br />

                    <small>
                      {agent.companyName}
                    </small>

                    <br />

                    <small>
                      {agent.phone}
                    </small>
                  </div>
                ))}
              </div>

            </div>

            <div className="modal-footer">

              <button
                className="done-btn"
                onClick={assignOrdersToAgent}
              >
                Assign Orders
              </button>

            </div>

          </div>
        </div>
      )}

    </div>
  );
}

export default Orders;